import {cs}          from "@Common/react/chain-services";
import {cnv, snv}    from "@Common/utils/arr-path";
import {createArray} from "@Common/utils/collections";
import {omit}        from "@Common/utils/objects";

import {BulkMailPermitBase} from "../../../../../common/heavy/bulk-mail-permit/bulk-mail-permit-base";

export const BulkMailPermitLogic = ({templateOptions, item, next: rootNext}) => cs(
    ["base", (_, next) => BulkMailPermitBase({templateOptions, initSelected: item?.selections?.idIndicia != null, next})],

    ["step1", (_, next) => rootNext({
        cleanItem: (item) => cnv(item, ["selections"], (_) => omit(_, ["idIndicia"])),
        next,
    })],

    ["available", ({base, step1: {method}}, next) => next(base.allowed && method === "shipping")],

    ({base, available, step1}) => step1.next(!available ? null : {
        summaryLines: base.selected.value && base.savedDetails && (() => {
            const permitPrice = templateOptions.options.find((option) => (option.group==="lineItem" && option.dev_key==="mailing_permit"));
            const unitPrice = (
                +(permitPrice.flatPrice ?? 0) +
                +(permitPrice.unitPrice ?? 0)
            );
            return [
                {
                    label: "Mailing Permit",
                    unitPrice,
                    details: createArray(5).map((i) => base.savedDetails["line" + (i+1)]),
                    qty: step1.totalQuantity,
                }
            ];
        })(),
        ui: {
            selected: base.selected,
            content: base.render(),
        },
        itemEditor: {
            $name: "bulk mail permit",
            prepareSave: (item) => ({
                newValue: !base.selected.value ? (
                    item
                ) : (
                    snv(item, ["selections", "idIndicia"], base.savedDetails.idPrimary)
                ),
                onSaved: base.saveSelected,
            }),

            changed: base.changed,

            valid: !base.selected.value || base.valid,
            errorsHandling: {
                highlightErrors: () => {
                    base.highlightErrors();
                },
            },
        },
    }),
);
